import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { AlertNotificationService } from '../../../services/alert-notification.service';
import { UserService } from '../../../services/api/user.service';
import { SelectFieldComponent } from '../../form/select-field/select-field.component';
import { SelectBaseOptionsFieldComponent } from '../select-base-options-field/select-base-options-field.component';
import { OptionService } from '../../../services/api/option.service';

@Component({
  selector: 'select-jurisdiction-types-field',
  imports: [SelectFieldComponent],
  templateUrl: '../select-base-options-field/select-base-options-field.component.html',
  styleUrl: '../select-base-options-field/select-base-options-field.component.scss'
})
export class SelectJurisdictionTypesComponent extends SelectBaseOptionsFieldComponent implements OnInit, OnDestroy {

    constructor(
      private alertNotificationService:AlertNotificationService, 
      private optionService: OptionService){
      super();
    }    override ngOnInit(): void {
      super.ngOnInit(); 
      this.getOptions(this.optionService.jurisdactionTypes(), this.alertNotificationService)
    }

    override ngOnDestroy(): void {
      super.ngOnDestroy(); 
    }
}
